import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ricerca-agenzie',
  templateUrl: './ricerca-agenzie.component.html',
  styleUrls: ['./ricerca-agenzie.component.scss']
})
export class RicercaAgenzieComponent implements OnInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [this.search?.nome],
      codice: [this.search?.codice],
      compagnia: [this.search?.compagnia],
      via: [this.search?.via],
      civico: [this.search?.civico],
      comune: [this.search?.comune],
      tel: [this.search?.tel],
      fax: [this.search?.fax],
      cell: [this.search?.cell],
      email: [this.search?.email],
    });

    this.form.valueChanges.subscribe(() => this.searchChange.emit(this.form.value));

  }

}
